import { SectionErrorBoundary } from './shared'
import { useHomepageVariants } from '../../Theme'

import type { ReactNode } from 'react'

interface HomepageSlotProps {
  /** Section name for error logging */
  name: string
  errorMessage: string
  kind?: 'banner' | 'default'
  children: ReactNode
}

/** One homepage slot: a themed section that fails alone, with its own message. */
export function HomepageSlot({ name, errorMessage, kind = 'default', children }: HomepageSlotProps) {
  const { homepageSectionVariants } = useHomepageVariants()

  return (
    <SectionErrorBoundary sectionName={name} errorMessage={errorMessage}>
      <section className={homepageSectionVariants({ kind })}>{children}</section>
    </SectionErrorBoundary>
  )
}
